import Actions from './domain-actions';
import Api from './domain-api';
import Collection from './domain-collection';
import Model from './domain-model';
import reducer from './domain-reducer';
import sagas from './domain-sagas';
import Selectors from './domain-selectors';

export default {
  Actions,
  Api,
  Collection,
  Model,
  namespace: 'domain',
  reducer,
  sagas:     [sagas],
  Selectors,
};
